var map = {
	"./google-play-badge-da-DK.svg": 5432,
	"./google-play-badge-de-DE.svg": 58458,
	"./google-play-badge-en-GB.svg": 81816,
	"./google-play-badge-en-US.svg": 25075,
	"./google-play-badge-es-ES.svg": 18116,
	"./google-play-badge-es-MX.svg": 31975,
	"./google-play-badge-fr-FR.svg": 14764,
	"./google-play-badge-it-IT.svg": 79746,
	"./google-play-badge-nb-NO.svg": 22417,
	"./google-play-badge-nl-NL.svg": 35592,
	"./google-play-badge-pl-PL.svg": 51520,
	"./google-play-badge-pt-BR.svg": 63404,
	"./google-play-badge-pt-PT.svg": 48080,
	"./google-play-badge-sv-SE.svg": 43985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;